"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.USER_PRODUCTIVITY_RESULT_FRAGMENT = void 0;
exports.USER_PRODUCTIVITY_RESULT_FRAGMENT = "\n  refId\n  compositeId\n  date\n";
